// React
import { ReactElement } from 'react';
// Masonry
import Masonry from 'react-masonry-css';
// Reach
// Utils
import { useTranslation } from 'next-i18next';
// Interfaces
import { IconsEnum } from '@utmb/types/icons';
// Design System
import { Button } from '@utmb/design-system/button/Button';
import { Card } from '@utmb/design-system/card/Card';
import { Icon } from '@utmb/design-system/icons/Icon';
// Styles
import styles from './magazine.module.scss';
import { useMags } from '@utmb/contexts/MagsContext';
import { MagazineFilters } from '@utmb/features/utmb-news/MagazineFilters';
import { DisplayListResult } from '@utmb/design-system/display-list-result/DisplayListResult';

export const Magazine = (): ReactElement => {
    const { t } = useTranslation();

    const { isLoaded, isMoreLoaded, mags, nbHits, loadMoreMags } = useMags();

    const breakpointColumnsObj = {
        default: 3,
        1200: 2,
        768: 1,
    };

    return (
        <>
            <MagazineFilters />

            <DisplayListResult hits={nbHits} />

            <Masonry breakpointCols={breakpointColumnsObj} className={styles.my_masonry_grid} columnClassName={styles.my_masonry_grid_column}>
                {mags?.map((mag) => (
                    <Card key={mag.id} {...mag} />
                ))}
            </Masonry>

            {isMoreLoaded && isLoaded ? (
                mags.length < nbHits && <Button.Default label={t('news.loadMore')} className={styles.button} onPress={loadMoreMags} />
            ) : (
                <div className={styles.loading_container}>
                    <Icon variant={IconsEnum.SPINNER} />
                </div>
            )}
        </>
    );
};
